import script from "./summary-statements-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-statements-modal.vue?vue&type=script&setup=true&lang=ts"

import "./summary-statements-modal.vue?vue&type=style&index=0&id=63acd0dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63acd0dc"]])

export default __exports__